export const errMsgGeneral = 'Ups! coś poszło nie tak';
export const errDescGeneral = 'Spróbuj jeszcze raz, względnie zgłoś błąd.';
export const errMsgWithCode = (errorCode:string) =>
  `Ups! coś poszło nie tak. Spróbuj jeszcze raz, względnie zgłoś błąd (kod błędu: ${errorCode})`;